import * as React from "react";
import { formatCurrency } from "app/utils/filters";

class BOInlineInputField extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      editing: false
    };
  }

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.setState({ editing: false });
      if (this.props.onEnter) {
        this.props.onEnter();
      }
    }
  };

  renderText = () => {
    const text = () => {
      switch (this.props.textFormat) {
        case "currency":
          return `R${formatCurrency(this.props.text)}`;
        default:
          return this.props.text;
      }
    };

    return (
      <span onDoubleClick={() => this.setState({ editing: true })}>
        {text()}
      </span>
    );
  };

  renderInput = () => {
    return (
      <input
        type="text"
        value={this.props.text}
        onChange={e => this.props.onChange(e.target.value)}
        onKeyPress={this.handleKeyPress}
      />
    );
  };

  render() {
    if (this.state.editing) {
      return this.renderInput();
    } else {
      return this.renderText();
    }
  }
}

export default BOInlineInputField;
